import { BoundingBox, Matrix, Vector } from '@moleculeone/types';
import { V4 } from './v4';

export function mget(matrix: Matrix, x: number, y: number): number {
  return matrix[x * 4 + y];
}

export function mdot(m1: Matrix, m2: Matrix, x: number, y: number): number {
  return (
    mget(m1, x, 0) * mget(m2, 0, y) +
    mget(m1, x, 1) * mget(m2, 1, y) +
    mget(m1, x, 2) * mget(m2, 2, y) +
    mget(m1, x, 3) * mget(m2, 3, y)
  );
}

export function expandToMinSize(bbox: BoundingBox, minsize: Vector): BoundingBox {
  const center = V4.average(bbox.max, bbox.min);
  const newSize = V4.max(V4.sub(bbox.max, bbox.min), minsize);
  const shift = V4.scale(newSize, 0.5);
  return { max: V4.add(center, shift), min: V4.sub(center, shift) };
}

export function expandToSquare(bbox: BoundingBox): BoundingBox {
  const center = V4.average(bbox.max, bbox.min);
  const size = V4.sub(bbox.max, bbox.min);
  const newEdgeLen = Math.max(size[0], size[1]);
  const shift = V4.scale(V4.vect(newEdgeLen, newEdgeLen), 0.5);
  return { max: V4.add(center, shift), min: V4.sub(center, shift) };
}
